module.exports = __webpack_public_path__ + "static/media/tabby_browse_template.b7dde52d.png";